export default "__VITE_ASSET__0120699c__"